var _path, _path2, _rect, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAdventures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 105,
    viewBox: "0 0 160 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133 23C133 21.8954 132.105 21 131 21C129.895 21 129 21.8954 129 23V29H123C121.895 29 121 29.8954 121 31C121 32.1046 121.895 33 123 33H129V39C129 40.1046 129.895 41 131 41C132.105 41 133 40.1046 133 39V33H139C140.105 33 141 32.1046 141 31C141 29.8954 140.105 29 139 29H133V23Z",
    fill: "#28EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 34.4667C65.5 27.4814 70.4804 21.489 77.3478 20.2113L106.909 14.7116C107.216 14.6544 107.5 14.8904 107.5 15.2032V104.5H65.5V34.4667Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 30.5,
    width: 8,
    height: 15,
    rx: 4,
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 104.5V52.6739L19.5652 66.5877C18.9326 66.7793 18.5 67.3624 18.5 68.0233V104.5H65.5Z",
    fill: "white",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 104.5H159.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 31 98)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 26 91)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 41 98)",
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 36 91)",
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 51 98)",
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 46 91)",
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 51,
    r: 14,
    fill: "url(#paint0_linear_1781_3315)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 51,
    r: 14,
    fill: "white",
    fillOpacity: 0.56
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1231 75.4599C29.3377 71.121 1.12895 46.1125 1.89514 44.2154C2.66241 42.3156 22.6362 58.2156 22.042 54.6479C21.7418 52.8449 9.78507 44.1069 10.5183 42.8513C10.9217 42.1606 16.0953 45.1338 19.663 47.5123",
    stroke: "black",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122 56.5H107.5V104.5H141.5V76C141.5 65.2304 132.77 56.5 122 56.5Z",
    fill: "white",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0625 40.7705C23.0941 31.5435 30.5737 24.0709 39.8034 24.0507C30.5737 24.0304 23.0941 16.5579 23.0625 7.33095C23.0308 16.5579 15.5513 24.0304 6.32165 24.0507C15.5513 24.0709 23.0309 31.5435 23.0625 40.7705Z",
    fill: "#A192FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1623 71.0593C59.5727 73.0002 59.2068 75.3905 57.891 76.8751C56.0922 78.9046 55 81.5747 55 84.4999C55 90.6838 59.881 95.7277 66.0005 95.9892V90.0099C66.0004 90.0036 66.0004 89.9973 66.0005 89.991V84.8043L59.363 81.3704C59.1178 81.2435 59.0218 80.9418 59.1487 80.6965C59.2756 80.4513 59.5773 80.3553 59.8225 80.4822L66.0005 83.6784V73.7834L63.3567 72.367C63.1132 72.2366 63.0216 71.9336 63.152 71.6902C63.2824 71.4467 63.5855 71.3551 63.8289 71.4855L66.0005 72.6489V68.5C66.0005 68.2239 66.2243 68 66.5005 68C66.7766 68 67.0005 68.2239 67.0005 68.5V73.3298C67.0394 73.4373 67.0415 73.5577 67.0005 73.6704V77.9084L71.3497 75.4893C71.5911 75.3551 71.8955 75.4419 72.0297 75.6832C72.164 75.9246 72.0771 76.229 71.8358 76.3632L67.0005 79.0527V84.5V89.1484L75.3491 84.4897C75.5903 84.3551 75.8948 84.4415 76.0294 84.6826C76.164 84.9238 76.0776 85.2283 75.8364 85.3629L67.0005 90.2936V95.9892C73.1196 95.7272 78 90.6835 78 84.4999C78 81.5747 76.9078 78.9046 75.109 76.8751C73.7932 75.3905 73.4273 73.0002 73.8377 71.0593C73.944 70.5563 74 70.0347 74 69.5C74 65.3579 70.6421 62 66.5 62C62.3579 62 59 65.3579 59 69.5C59 70.0347 59.056 70.5563 59.1623 71.0593Z",
    fill: "#21C35D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74.0002V85.0002H81L91 74.0002Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98 66V74H91L98 66Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0003 54V64H82.0003L91.0003 54Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0002 91V97H93.0002L98.0002 91Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0005 68.5C66.0005 68.2239 66.2243 68 66.5005 68C66.7766 68 67.0005 68.2239 67.0005 68.5H66.0005ZM66.8165 79.1551C66.5751 79.2893 66.2707 79.2025 66.1365 78.9612C66.0022 78.7198 66.0891 78.4154 66.3304 78.2812L66.8165 79.1551ZM75.3491 84.4896C75.5903 84.3551 75.8948 84.4415 76.0294 84.6826C76.164 84.9238 76.0776 85.2283 75.8364 85.3629L75.3491 84.4896ZM66.7441 90.4366C66.503 90.5712 66.1984 90.4848 66.0639 90.2436C65.9293 90.0025 66.0157 89.6979 66.2568 89.5634L66.7441 90.4366ZM59.363 81.3704C59.1178 81.2435 59.0218 80.9418 59.1487 80.6965C59.2756 80.4513 59.5773 80.3553 59.8225 80.4822L59.363 81.3704ZM71.3497 75.4893C71.5911 75.3551 71.8955 75.4419 72.0297 75.6832C72.164 75.9246 72.0771 76.229 71.8358 76.3632L71.3497 75.4893ZM66.7665 73.0593C67.0099 73.1897 67.1015 73.4927 66.9711 73.7361C66.8407 73.9795 66.5376 74.0711 66.2942 73.9407L66.7665 73.0593ZM63.3567 72.367C63.1132 72.2366 63.0216 71.9336 63.152 71.6902C63.2824 71.4467 63.5855 71.3551 63.8289 71.4855L63.3567 72.367ZM66.0005 84.5V68.5H67.0005V84.5H66.0005ZM75.8364 85.3629L66.7441 90.4366L66.2568 89.5634L75.3491 84.4896L75.8364 85.3629ZM59.8225 80.4822L66.7302 84.0559L66.2707 84.9441L59.363 81.3704L59.8225 80.4822ZM71.8358 76.3632L66.8165 79.1551L66.3304 78.2812L71.3497 75.4893L71.8358 76.3632ZM63.8289 71.4855L66.7665 73.0593L66.2942 73.9407L63.3567 72.367L63.8289 71.4855ZM66.0005 97V84.5H67.0005V97H66.0005Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.326 81.9662C114.827 80.112 114.902 78.1503 115.541 76.3397C116.18 74.529 117.352 72.9544 118.904 71.8233C120.455 70.6923 122.313 70.0579 124.232 70.0038C126.151 69.9497 128.042 70.4783 129.655 71.5202C131.268 72.562 132.527 74.068 133.267 75.8398C134.006 77.6116 134.192 79.5659 133.799 81.4453C133.406 83.3246 132.452 85.0407 131.064 86.3674C129.676 87.694 127.919 88.569 126.024 88.877L125.414 85.1262C126.551 84.9414 127.606 84.4164 128.439 83.6204C129.271 82.8244 129.843 81.7948 130.079 80.6672C130.315 79.5396 130.204 78.367 129.76 77.3039C129.316 76.2408 128.561 75.3372 127.593 74.7121C126.625 74.087 125.491 73.7698 124.339 73.8023C123.188 73.8347 122.073 74.2154 121.142 74.894C120.211 75.5726 119.508 76.5174 119.125 77.6038C118.741 78.6902 118.696 79.8672 118.995 80.9797L115.326 81.9662Z",
    fill: "#FFC2FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1781_3315",
    x1: 33.5,
    y1: 63.5,
    x2: 57.5,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0286886,
    stopColor: "#1DE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972336,
    stopColor: "#FE60B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAdventures);
export default __webpack_public_path__ + "static/media/no-adventures.df75f52969f80b2f67759cdcf290d36d.svg";
export { ForwardRef as ReactComponent };